<template>
    <div class="w-full h-full relative">
        <Header :title="'Einstellungen'" />
        <content-container class="bg-white">
            <settings-form
                @change="(user) => UPDATE_USER(user)"
                @change-password="(user) => UPDATE_PASSWORD(user)"
            />
        </content-container>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import ContentContainer from "../../components/layout/ContentContainer.vue";
import Header from "../../components/layout/Header.vue";
import {
    AUTH_TYPES,
    AUTH_USER_TYPES,
    HELPER_TYPES,
    STORE_TYPES,
} from "../../store/types";
import SettingsForm from "./SettingsForm.vue";

export default defineComponent({
    name: "Settings",
    components: { Header, ContentContainer, SettingsForm },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});

        /**
         *  Functions
         */
        async function UPDATE_USER(user) {
            await store.dispatch(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.UPDATE_USER}`,
                { user }
            );
        }
        async function UPDATE_PASSWORD(user) {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "save-password-button"
            );
            await store.dispatch(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.UPDATE_PASSWORD}`,
                { user }
            );

            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "save-password-button"
            );
        }
        /**
         *  Computed
         */
        const GET_USER = computed(
            () => store.getters[`${STORE_TYPES.AUTH}/${AUTH_TYPES.GET_USER}`]
        );

        /**
         *  Created
         */

        return { state, GET_USER, UPDATE_USER, UPDATE_PASSWORD };
    },
});
</script>
